import Vue from 'vue'


Vue.filter('currency', function (value) {
    if (!value) return ''
    return '$' + parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
  })
  